module.exports = "<p>\n  drag-and-drop-list works!\n</p>\n"